import DesktopHeader from './DesktopHeader';

export default DesktopHeader;
